<template>
<div class="page-points-address container">
    <div class="container-flex points-address-list" :class="addressList.length > 0 ? 'bg' : ''">
        <div class="points-address-item" v-for="(item,index) in addressList" :key="index"  @click="selectClick(item)">
            <div class="points-address-info">
                <div class="points-address-info-flex">
                    <div class="address-name">
                        {{item.contacts}} <span class="phone">{{item.contactsPhone}}</span>
                    </div>
                    <div class="address-text">{{item.fullAddress}}</div>
                </div>
                <div class="points-address-up-icon v-center" @click="upItem(item)" v-if="!isSelect">
                    <img class="right-icon" src="../../assets/image/updata.png" />
                </div>
            </div>
        </div>
        <div class="no-list-data" v-if="addressList.length > 0">暂无更多数据</div>
        <div class="no-address" v-if="addressList.length == 0">
            <div class="no-address-text">暂无地址信息</div>
        </div>
    </div>
</div>
</template>

<script>
import { getPprMallAddress } from "../../common/api/index";

export default {
  name: "points-address-oper",
  components: {
   
  },
  data() {
    return {
      isSelect: false,
      loading: false,
      addressList: []
    };
  },
  methods: {
    async getPprMallAddress(){
      this.loading = true;
      let ret = await getPprMallAddress({});
      if (ret.status === 0) {
        let data = ret.data || [];
        let addressList = [];
        data.map(item=>{
          if(item.status == 1){
            addressList.push(item);
          }
        })
        this.addressList = addressList;
      }
      this.loading = false;
    },   
    selectClick(item){
      if(this.isSelect){
        this.$common.save('selectOprAddress',item);
        this.$common.goBack();
      }
    },
  },
  mounted() {
    if(this.$route.query.type == 'select'){
      this.isSelect = true;
    }
    this.getPprMallAddress();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.points-address-list{
    padding: 0.20rem;
    position: relative;
}
.points-address-item{
    background-color: #fff;
    border-radius: 0.12rem;
    margin-top: 0.20rem;
    font-size: 0.24rem;
    line-height: 0.33rem;
    color: #666;
}
.points-address-item:first-child{
    margin-top: 0;
}
.points-address-info{
    padding: 0.20rem;
    display: flex;
}
.points-address-info-flex{
    flex: 1;
}
.points-address-info .address-name{
    font-size: 0.28rem;
    line-height: 0.40rem;
    color: #000;
}
.points-address-info .phone{
    margin-left: 0.10rem;
}
.points-address-info .address-text{
    margin-top: 0.13rem;
}

.address-ops{
    display: flex;
    padding: 0.20rem;
    border-top: 1px solid #F5F4F9;
}
.address-ops-flex{
    flex: 1;
}
.radio ,.address-del-icon,.right-icon{
    width: 0.30rem;
    height: 0.30rem;
    display: inline-block;
    vertical-align: text-bottom;
}
.address-del{
    padding-left: 0.20rem;
}
.points-address-up-icon{
    padding-left: 0.20rem;
}
.add-btn-box{
   padding: 0.20rem;
}
.no-address{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
}
.no-address-icon{
    width: 1.50rem;
    height: 0.97rem;
}
.no-address-text{
    margin-top: 0.30rem;
    color: #999
}
</style>
